// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__1Jsiz","danger":"Alert_danger__1J9Vg","info":"Alert_info__3RBx-","alert__text":"Alert_alert__text__3IwBm"};